module.exports = __webpack_public_path__ + "static/media/france.23e74777.svg";